import { Clearance, ExecutionOptions } from "zodiac-roles-deployments";
export const reconstructPermissions = (targets) => {
    return targets.flatMap((target) => {
        if (target.clearance === Clearance.None) {
            return [];
        }
        if (target.clearance === Clearance.Target) {
            return {
                targetAddress: target.address,
                send: allowsSend(target.executionOptions),
                delegatecall: allowsDelegateCall(target.executionOptions),
            };
        }
        if (target.clearance === Clearance.Function) {
            return target.functions.map((func) => ({
                targetAddress: target.address,
                selector: func.selector,
                send: allowsSend(func.executionOptions),
                delegatecall: allowsDelegateCall(func.executionOptions),
                condition: !func.wildcarded ? func.condition : undefined,
            }));
        }
        throw new Error(`Unknown clearance ${target.clearance}`);
    });
};
const allowsSend = (execOptions) => execOptions === ExecutionOptions.Send || execOptions === ExecutionOptions.Both;
const allowsDelegateCall = (execOptions) => execOptions === ExecutionOptions.DelegateCall ||
    execOptions === ExecutionOptions.Both;
